import { FunctionComponent } from "react";
import styled from "styled-components";
import Image from "next/image";

import { colours } from "@/utils";
import MarketingLink from "../../MarketingLink";
import { Device } from "@/utils/device";
import { CXL } from "@/components/Typography";
import FramedImage from "../../spaces/FramedImage";

const copy = [
  "Boost your skills with 200+ AllBright Academy courses delivered by renowned subject matter experts on everything from career progression, leadership development, workplace wellbeing and future technologies.",
  <br key="1" />,
  <br key="2" />,
  "AllBright Academy is open to all Virtual members.",
];

const images = [
  {
    imagePath: "/images/marketing/courses/academy-mentorship-collection.jpg",
    alt: "two women in conversation at a desk",
    subtitle: "Mentorship Collection",
  },
  {
    imagePath:
      "/images/marketing/courses/academy-navigating-times-of-uncertainy.jpg",
    alt: "two women talking at a networking event",
    subtitle: "Navigating Times of Uncertainty",
  },
  {
    imagePath:
      "/images/marketing/courses/academy-cultivate-clear-communication.png",
    alt: "three women speaking at a panel event",
    subtitle: "Cultivate Clear Communication",
  },
];

const AllBrightAcademyContent: FunctionComponent = () => {
  return (
    <>
      <S.Section>
        <S.TextContent>
          <S.Title>
            AllBright Acade<i>m</i>y
          </S.Title>
          <S.Subheading>{copy.map((text) => text)}</S.Subheading>
          <S.LinkContainer>
            <MarketingLink
              href="/memberships/virtual"
              linkText="Virtual Membership"
              textColour={colours.charcoal}
              colour={colours.charcoal}
            />
          </S.LinkContainer>
        </S.TextContent>
        <S.ImagesContainer>
          {images.map((item) => {
            return (
              <S.CourseContent key={item.subtitle}>
                <FramedImage imgSrc={item.imagePath} alt={item.alt} />
                <S.Copy>{item.subtitle}</S.Copy>
              </S.CourseContent>
            );
          })}
        </S.ImagesContainer>
      </S.Section>
      <S.PhonesContainer>
        <Image
          src="/images/marketing/academy-phones.png"
          alt=""
          layout="fill"
          objectFit="contain"
          objectPosition="top left"
        />
      </S.PhonesContainer>
    </>
  );
};

const S = () => {};

S.Section = styled.section`
  padding: 4rem 10%;
  background-color: ${colours.shell};
  display: flex;
  flex-direction: column;
  color: #0b0b29;

  @media (min-width: ${Device.tablet}) {
    flex-direction: row;
    justify-content: center;
  }
`;

S.TextContent = styled.div`
  width: 100%;

  @media (min-width: ${Device.tablet}) {
    padding-top: 5rem;
    padding-right: 10rem;
    width: 60vw;
  }

  @media (min-width: ${Device.desktop}) {
    padding: 10rem 15rem 0 2rem;
  }
`;

S.Title = styled.h2`
  font-size: 7rem;
  font-weight: 100;
  color: ${colours.charcoal};
  line-height: 6rem;
  font-family:
    Roxborough CF,
    sans-serif;
  margin-bottom: 3rem;

  @media (min-width: ${Device.tablet}) {
    font-size: 8rem;
    margin-bottom: 4rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 10rem;
    margin-bottom: 6rem;
    line-height: 8.5rem;
  }
`;

S.Subheading = styled.p`
  margin-bottom: 2rem;
  font-weight: 500;
  white-space: pre-line;

  @media (min-width: ${Device.tablet}) {
    font-size: 1.8rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 2rem;
  }
`;

S.LinkText = styled.p`
  text-decoration: underline;
  padding-bottom: 1.5rem;
`;

S.LinkContainer = styled.div`
  padding-top: 1.5rem;
`;

S.ImagesContainer = styled.div`
  display: none;

  @media (min-width: ${Device.tablet}) {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
`;

S.CourseContent = styled.div`
  @media (min-width: ${Device.tablet}) {
    flex-shrink: 0;
    width: 210px;
  }

  @media (min-width: ${Device.desktop}) {
    flex-shrink: 0;
    width: 300px;
  }
`;

S.Copy = styled(CXL)`
  padding: 0.5rem 0 2rem 0;
  font-weight: 100;
  font-size: 1.5rem;
  line-height: 2.125rem;
  color: ${colours.charcoal};

  @media (min-width: ${Device.tablet}) {
    font-weight: 300;
  }

  @media (min-width: ${Device.desktop}) {
    font-weight: 400;
  }
`;

S.PhonesContainer = styled.div`
  height: 300px;
  width: 100%;
  position: relative;
  margin-bottom: -1px;

  background-image: url("/images/marketing/yellow-tessellation.svg");
  background-size: 1000px;
  background-repeat: no-repeat;
  background-position: bottom;

  @media (min-width: ${Device.tablet}) {
    height: 350px;
    top: -290px;
    margin-bottom: -300px;
  }

  @media (min-width: ${Device.desktop}) {
    height: 550px;
    top: -390px;
    margin-bottom: -400px;
    background-size: 1500px;
  }
`;

export default AllBrightAcademyContent;
